import React from 'react';
import {
  Checkbox,
  CheckboxIcon,
  CheckboxIndicator,
  CheckboxLabel,
  VStack,
} from '@gluestack-ui/themed';
import { CheckIcon } from 'lucide-react-native';
import { useTranslation } from 'react-i18next';

import type { ReferringResource } from '@/common/api/models/referringResource';

type Props = {
  resources: ReferringResource[];
  selectedIds: string[];
  onToggle: (resourceId: string, checked: boolean) => void;
};

export function SwapResourceRelevance({ resources, selectedIds, onToggle }: Props) {
  const { t } = useTranslation();

  if (!resources.length) return null;

  return (
    <VStack space="sm">
      {resources.map((resource) => {
        const label = t('lecturer.scheduledChanges.swap.toggleExamRelevance', { title: resource.title });
        return (
          <Checkbox
            key={resource.id}
            value={resource.id}
            size="sm"
            isChecked={selectedIds.includes(resource.id)}
            onChange={(checked) => onToggle(resource.id, checked)}
            aria-label={label}
            testID={`scheduled-swap-resource-${resource.id}`}
          >
            <CheckboxIndicator mr="$2" mt="$0.5">
              <CheckboxIcon as={CheckIcon} />
            </CheckboxIndicator>
            <CheckboxLabel size="sm" color="$textBody">
              {label}
            </CheckboxLabel>
          </Checkbox>
        );
      })}
    </VStack>
  );
}
